/**
 * MN Planning FAQ — title icon on view; smooth exclusive accordion.
 */
class MnPlanningFaq extends HTMLElement {
  constructor() {
    super();
    this.intersectionObserver = null;
    this.handleClick = this.handleClick.bind(this);
  }

  connectedCallback() {
    this.setupDecor();
    this.setupAccordion();
  }

  disconnectedCallback() {
    this.intersectionObserver?.disconnect();
    this.intersectionObserver = null;
    this.querySelectorAll('[data-mn-planning-item] .mn-planning-faq__summary').forEach((button) => {
      button.removeEventListener('click', this.handleClick);
    });
  }

  setupDecor() {
    const decor = this.querySelector('[data-mn-planning-decor]');
    if (!(decor instanceof HTMLElement) || !decor.classList.contains('mn-planning-faq__decor--ready')) {
      return;
    }

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      decor.classList.add('is-in-view');
      return;
    }

    this.intersectionObserver = new IntersectionObserver(
      (entries) => {
        const visible = entries.some((entry) => entry.isIntersecting);
        if (!visible) return;
        decor.classList.add('is-in-view');
        this.intersectionObserver?.disconnect();
        this.intersectionObserver = null;
      },
      { threshold: 0.25, rootMargin: '0px 0px -8% 0px' }
    );

    this.intersectionObserver.observe(this);
  }

  setupAccordion() {
    this.querySelectorAll('[data-mn-planning-item] .mn-planning-faq__summary').forEach((button) => {
      button.addEventListener('click', this.handleClick);
    });
  }

  handleClick(event) {
    const button = event.currentTarget;
    if (!(button instanceof HTMLElement)) return;

    const item = button.closest('[data-mn-planning-item]');
    if (!(item instanceof HTMLElement)) return;

    const willOpen = !item.classList.contains('is-open');

    this.querySelectorAll('[data-mn-planning-item]').forEach((other) => {
      if (other === item) return;
      this.setOpen(other, false);
    });

    this.setOpen(item, willOpen);
  }

  setOpen(item, open) {
    const button = item.querySelector('.mn-planning-faq__summary');
    const panel = item.querySelector('.mn-planning-faq__panel');

    item.classList.toggle('is-open', open);

    if (button instanceof HTMLElement) {
      button.setAttribute('aria-expanded', open ? 'true' : 'false');
    }

    if (panel instanceof HTMLElement) {
      if (open) {
        panel.removeAttribute('inert');
      } else {
        panel.setAttribute('inert', '');
      }
    }
  }
}

if (!customElements.get('mn-planning-faq')) {
  customElements.define('mn-planning-faq', MnPlanningFaq);
}
